import { observer } from "mobx-react";
import { useEffect, useCallback } from "react";
import { useStore } from "../../../../../hooks";
import UnifiedProfileTabs from "../UnifiedProfileTabs/UnifiedProfileTabs";
import { UCPAgentVersion } from "../../../../../utils/enums";

const Assistance = observer(() => {
  const { authStore, assistanceUCPStore, historyAgentStore } = useStore();

  const { selectedAccount } = authStore;
  
  useEffect(() => {
    if (selectedAccount?.id) {
      assistanceUCPStore.cleanupConversation();
      assistanceUCPStore.fetchConciergeAgent(selectedAccount.id);
      assistanceUCPStore.setCustomer(authStore.userId);
    }
  }, [selectedAccount?.id, assistanceUCPStore, authStore.userId]);

  useEffect(() => {
    return () => {
      assistanceUCPStore.cleanupConversation();
    };
  }, [assistanceUCPStore]);

  /**
   * Handle tab change event by setting the active tab state and
   * updating the selected tab in the assistance store.
   * @param {string} tabLabel - The label of the tab that was clicked.
   */
  const handleTabChange = useCallback(
    (tabLabel) => {
      assistanceUCPStore.setSelectedTab(tabLabel);
    },
    [assistanceUCPStore]
  );

  const handleSwitchChange = (event) => {
    const isChecked = event.target.checked;
    const version = isChecked ? UCPAgentVersion.BETA : UCPAgentVersion.DEFAULT;
    assistanceUCPStore.setAgentVersion(version);
  };
  useEffect(() => {
    if (assistanceUCPStore.conciergeAgent) {
      historyAgentStore.fetchConversations(
        assistanceUCPStore.conciergeAgent.id,
        authStore.userId
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assistanceUCPStore.conciergeAgent, authStore.userId]);

  return (
    <>
      <UnifiedProfileTabs
        onTabChange={handleTabChange}
        onSwitchChange={handleSwitchChange}
        showSearch={true}
      />
    </>
  );
});

export default Assistance;
